/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ tier: NonNullable<unknown> }} Upgradetoplan2Inputs */

const en_upgradetoplan2 = /** @type {(inputs: Upgradetoplan2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Upgrade to ${i?.tier}`)
};

const de_upgradetoplan2 = /** @type {(inputs: Upgradetoplan2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Auf ${i?.tier} wechseln`)
};

/**
* | output |
* | --- |
* | "Upgrade to {tier}" |
*
* @param {Upgradetoplan2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const upgradetoplan2 = /** @type {((inputs: Upgradetoplan2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Upgradetoplan2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_upgradetoplan2(inputs)
	return de_upgradetoplan2(inputs)
});
export { upgradetoplan2 as "upgradeToPlan" }